<template>
  <div class="page-editor editor-wrapper" v-loading="loading">
    <!--左侧导航-->
    <div class="editor-side-bar">
      <el-tabs tab-position="left" v-model="activeSideBar" style="height: 100%">
        <el-tab-pane
          v-for="(item, index) in sidebarMenus"
          :key="index"
          :name="item.value"
        >
          <el-tooltip
            slot="label"
            class="item"
            effect="dark"
            :content="item.label"
            placement="right"
          >
            <i :class="item.elementUiIcon"></i>
          </el-tooltip>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!--组件&页面&模板-->
    <div class="editor-page-edit-wrapper">
      <componentManage
        v-if="activeSideBar === 'componentList'"
        ref="component-manage"
      ><componentLibs /></componentManage>
      <pageManage v-if="activeSideBar === 'pageManage'" />
      <templateLibs v-if="activeSideBar === 'templateLibs'" />
    </div>
    <!--页面编辑区域-->
    <div class="control-bar-wrapper">
      <controlBar
        :scale.sync="canvasConfig.scale"
        :pageData="projectData"
        @import-psd-data="importPsdData"
        @showPreview="showPreviewFn"
        @cancel="cancelFn"
        @publish="publishFn"
        @onlyPreview="onlyPreview"
        @showPreviewFn="showPreviewFn"
        @save="saveFn"
      />
    </div>
    <div class="editor-main">
      <editorPan
        :scale.sync="canvasConfig.scale"
        @manageRefresh="manageRefresh"
      />
    </div>
    <!--属性编辑区域-->
    <div class="el-attr-edit-wrapper scrollbar-wrapper">
      <el-tabs v-model="activeAttr" stretch>
        <el-tab-pane label="属性" name="属性">
          <attrEdit v-if="activeElementUUID && activeElementUUIDMore.length <= 1"></attrEdit>
          <attrEditMore
            v-if="activeElementUUIDMore.length > 1"
            @createGroup="createGroup"
            @cancelGroup="cancelGroup"
            @manageRefresh="manageRefresh"
          ></attrEditMore>
          <pageAttrEdit v-if="!activeElementUUID"></pageAttrEdit>
        </el-tab-pane>
        <el-tab-pane label="动作" name="动作">
          <eventEdit></eventEdit>
        </el-tab-pane>
        <el-tab-pane label="动画" name="动画" v-if="activeElementUUID">
          <animationEdit></animationEdit>
        </el-tab-pane>
        <!-- <el-tab-pane label="JS脚本" name="脚本">
          <scriptEdit></scriptEdit>
        </el-tab-pane> -->
        <!-- <el-tab-pane label="页面" name="页面属性">
          <pageAttrEdit></pageAttrEdit>
        </el-tab-pane> -->
        <el-tab-pane label="项目" name="项目属性">
          <productAttrEdit></productAttrEdit>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!--预览-->
    <previewPage
      v-if="showPreview"
      :pageData="projectData"
      :pageId="id"
      @closePreview="showPreview = false"
      @publishFn="publishFn"
      @saveFn="saveFn"
    ></previewPage>
    <!--我的图片-->
    <imageLibs />
  </div>
</template>

<script>
import componentLibs from "./components/component-libs/Index";
import componentManage from "./components/component-manage";
import pageManage from "./components/page-manage";
import templateLibs from "./components/template-libs";
import editorPan from "./components/editor-panel/Index";
// 属性编辑相关组件
import attrEdit from "./components/attr-configure/attr-edit";
import attrEditMore from "./components/attr-configure/attr-edit-more";
import animationEdit from "./components/attr-configure/animation-edit";
import eventEdit from "./components/attr-configure/event-edit";
import pageAttrEdit from "./components/attr-configure/page-attr-edit";
import productAttrEdit from "./components/attr-configure/product-attr-edit";
// import scriptEdit from './components/attr-configure/script-edit'

import controlBar from "./components/control-bar";

import previewPage from "./components/preview";
import imageLibs from "@client/components/image-libs";

import { mapState, mapGetters } from "vuex";
import html2canvas from "html2canvas";

export default {
  components: {
    componentLibs,
    pageManage,
    templateLibs,
    imageLibs,
    editorPan,
    attrEdit,
    attrEditMore,
    animationEdit,
    eventEdit,
    pageAttrEdit,
    productAttrEdit,
    // scriptEdit,
    controlBar,
    previewPage,
    componentManage,
  },
  data() {
    return {
      id: "", // 当前页面id
      templateId: "", // 当前模板id
      loading: false,
      showPreview: false,
      activeAttr: "属性",
      activeSideBar: "componentList",
      sidebarMenus: [
        // {
        //   label: "元件库",
        //   value: "componentLibs",
        //   elementUiIcon: "el-icon-s-operation",
        // },
        {
          label: "元件管理",
          value: "componentList",
          elementUiIcon: "el-icon-folder-opened",
        },
        {
          label: "页面管理",
          value: "pageManage",
          elementUiIcon: "el-icon-document",
        },
        // {
        // 	label: '模板库',
        // 	value: 'templateLibs',
        // 	elementUiIcon: 'el-icon-files'
        // }
      ],
      canvasConfig: {
        scale: 0.6,
      },
    };
  },
  computed: {
    ...mapState({
      projectData: (state) => state.editor.projectData,
      activePageUUID: (state) => state.editor.activePageUUID,
      activeElementUUID: (state) => state.editor.activeElementUUID,
      activeElementUUIDMore: (state) => state.editor.activeElementUUIDMore,
      activeElementGroupUUID: (state) => state.editor.activeElementGroupUUID,
    }),
    ...mapGetters(["activePage"]),
  },
  created() {
    this.$store.dispatch("setPrjectData");
    this.id = this.$route.query.id || this.$route.query.templateId;
    this.templateId = this.$route.query.templateId;
    this.initPageData();
  },
  methods: {
    keypressHandler(e){
      console.log(e, 'keypressHandler')
    },
    manageRefresh() {
      this.activeSideBar === "componentList" &&
        this.$refs["component-manage"].listRefresh();
    },
    createGroup() {
      if (!this.activePage.elementGroups) {
        this.activePage.elementGroups = [];
      }
      let alreadyPushed = false;
      this.activePage.elementGroups.map((i) => {
        i.list.map((m) => {
          if (this.activeElementUUIDMore.includes(m)) {
            alreadyPushed = true;
          }
        });
      });
      if (!alreadyPushed) {
        this.$store.dispatch("addElementGroups");
      }
    },
    cancelGroup() {
      this.$store.dispatch("deleteElementGroups");
    },
    /**
     * 初始化页面数据
     */
    initPageData() {
      this.loading = true;
      this.$API
        .getPageDetail({ exhibitionId: this.id, flag: this.templateId?2:1 })
        .then((res) => {
          this.loading = false;
          if(res.data.content && res.data.content != null){
            this.$store.dispatch("setPrjectData", {
              ...JSON.parse(res.data.content),
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    /**
     * 保存
     */
    async saveFn() {
      // await this.screenshots()
      // 提交数据再预览
      this.$API.updatePage({ content: JSON.stringify(this.projectData), templateId: this.id, flag: this.templateId?2:1 }).then(() => {
        this.$message.success("保存成功!");
        this.showPreview = false;
      });
    },
    /**
     * 保存
     */
    async publishFn() {
      // 提交数据再预览
      // let data = { ...this.projectData };
      // data.isPublish = true;
      this.$API.updatePage({ pageData: JSON.stringify(this.projectData) }).then(() => {
        this.$message.success("已成功保存并发布!");
        this.showPreview = false;
        window.open(process.env.VUE_APP_PREVIEW_URL + "?id=" + this.id+ '&pid=' + this.activePage.uuid );
        //   this.$router.push({name: 'pageList'})
      });
    },
    async onlyPreview() {
      // this.$API.updatePage({ pageData: this.projectData }).then(() => {
      //   window.open(
      //     this.$config.baseURL + "/quark/view/" + this.projectData._id + '?pid=' + this.activePage.uuid 
      //   );
      // });
      window.open(process.env.VUE_APP_PREVIEW_URL + "?id=" + this.id+ '&pid=' + this.activePage.uuid);
    },
    async showPreviewFn() {
      // await this.screenshots()
      // 提交数据再预览
      this.$API.updatePage({ content: JSON.stringify(this.projectData), templateId: this.id, flag: this.templateId?2:1 }).then(() => {
        this.$message.success("保存成功!");
        this.showPreview = false;
        window.open(process.env.VUE_APP_PREVIEW_URL + "?id=" + this.id+ '&pid=' + this.activePage.uuid );
      });
    },
    /**
     * 退出
     */
    cancelFn() {
      this.$confirm("当前修改内容未保存,确认退出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if(history.length == 2){
            window.opener = null;
            window.open("", "_self");
            window.close();
          }else{
            history.back();
          }
        })
        .catch(() => {});
    },
    /**
     * 提供截屏作为项目主图
     */
    screenshots() {
      const el = document.querySelector("#canvas-panel");
      return new Promise((resolve, reject) => {
        html2canvas(el, {
          proxy: `${this.$config.baseURL}/common/html2canvas/corsproxy`,
        }).then((canvas) => {
          const dataUrl = canvas.toDataURL("image/jpeg", 0.6);
          const blob = this.$mUtils.dataURItoBlob(dataUrl);
          const file = new window.File([blob], +new Date() + ".png", {
            type: "image/png",
          });
          let params = new FormData();
          params.append("file", file);
          this.$axios
            .post("/common/uploadFile", params)
            .then((res) => {
              // 替换主图链接
              this.projectData.coverImage = res.body;
              resolve(res.body);
            })
            .catch((err) => {
              reject(err);
            });
        });
      });
    },
    /**
     *
     * @param dataList
     */
    importPsdData(psdData) {
      let elementsList = psdData.elements;
      let psdWidth = psdData.document.width;
      let scalingRatio = this.projectData.width / psdWidth;
      elementsList.forEach((item) => {
        let { width, height, top, left, imageSrc, opacity, zIndex } = item;
        setTimeout(() => {
          this.$store.dispatch("addElement", {
            elName: "qk-image",
            defaultStyle: {
              width: width * scalingRatio,
              height: height * scalingRatio,
              top: top * scalingRatio,
              left: left * scalingRatio,
              zIndex: zIndex,
              opacity,
            },
            needProps: {
              imageSrc: imageSrc,
            },
          });
        }, 10);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__item {
  color: #fff;
  &.is-active {
    color: #416bf4;
}
}
.editor-wrapper {
  display: flex;
  height: 100%;
  position: relative;
  background: #0c132b;
  .editor-side-bar {
    flex-shrink: 0;
    width: 55px;
  }
  .editor-page-edit-wrapper {
    flex-shrink: 0;
    width: 210px;
    padding: 0 1px;
  }
  .editor-main {
    overflow: auto;
    flex: 1;
    background: #1f2353;
    position: relative;
  }
  .el-attr-edit-wrapper {
    flex-shrink: 0;
    width: 380px;
    padding: 0;
    color: #fff;
  }
}

.control-bar-wrapper {
  position: absolute;
  top: -44px;
  left: 50%;
  transform: translateX(-50%);
  width: auto;
  text-align: center;
  z-index: 1000;
}
</style>
<style lang="scss">
.el-tabs__nav-wrap::after{
  background-color: unset;
}
.editor-side-bar {
  .el-tabs__item {
    color: #fff;
  }
  .el-tabs__item.is-active {
    color: #fff;
    background: #3669f8;
  }
}

.el-attr-edit-wrapper {
  .el-tabs {
    height: 100%;
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 10px;
  }
  .el-tabs__content {
    height: calc(100% - 55px);
    & > div {
      height: 100%;
    }
    .attr-edit-inner {
      padding-left: 16px;
      padding-right: 16px;
    }
  }
}
</style>
